import React from "react"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"

interface Props {
	children?: React.ReactNode
}

const FormFieldLabel = ({ children }: Props) => {
	const { isMobile } = useScreenType()

	return (
		<div
			style={{
				fontSize: isMobile ? 16 : 14,
				width: "100%",
				whiteSpace: "normal",
			}}
			children={children}
		/>
	)
}

export default FormFieldLabel
